import {
  Box,
  Button,
  Card,
  Grid,
  IconButton,
  Modal,
  Toolbar,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import React, { useEffect, useRef, useState } from "react";
import PlaceIcon from "@mui/icons-material/Place";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import DeleteIcon from "@mui/icons-material/Delete";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

import axios from "axios";
import { CategoryOutlined, Lock, Pending } from "@mui/icons-material";
import Details from "./Details";
import { useMessage } from "../../components/Header";
import { IoIosMore, IoMdLock } from "react-icons/io";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { useTheme } from "../../style/theme";
import { MdExpandLess } from "react-icons/md";

import { TfiMoreAlt } from "react-icons/tfi";
import { TbEdit } from "react-icons/tb";
const JobListingCard = (props) => {
  const {
    title,
    location,
    experience,
    details,
    jobType,
    salary,
    id,
    departmentId,
    refresh,
    editJob,
    copyJob,
    departments,
    remote,
    deletingModal,
    setDeleting,
    handleCopy
  } = props;
  const [accordionOpen, setAccordionOpen] = useState(false);
  const [open, setOpen] = React.useState(false);
  // const [deletingModal, setDeleting] = useState(false);
  const { showError, showSuccess } = useMessage();
  const OpenDeleteModal = () => setDeleting(true);
  const CloseDeleteModal = () => setDeleting(false);
  const { mode } = useTheme();
  const style = {
    width: "100%",

    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
  };

  const handleExpand = () => {
    setAccordionOpen((show) => !show);
  };

  async function deletejob(id) {
    try {
      const res = await axios.delete(`/hr/job-listing/${id}`);
      const { success, message } = res.data;
      if (success) {
        showSuccess("Job deleted successfully");
      } else {
        showError(message);
      }
    } catch (e) { }

    refresh();
  }

  const handleClose = () => setOpen(false);
  const [openModal, setOpenModal] = useState(false);

  const toggleModal = () => {
    setOpenModal((prev) => !prev);
  };

  const modalRef = useRef(null); // Reference for the modal content
  const buttonRef = useRef(null); // Reference for the button that opens the modal
  useEffect(() => {
    // Function to handle clicks outside the modal
    const handleClickOutside = (event) => {
      if (
        modalRef.current &&
        !modalRef.current.contains(event.target) &&
        !buttonRef.current.contains(event.target)
      ) {
        setOpenModal(false); // Close the modal if clicked outside
      }
    };

    // Add event listener for clicks outside
    document.addEventListener("mousedown", handleClickOutside);

    // Cleanup the event listener on unmount
    // return () => {
    //   document.removeEventListener('mousedown', handleClickOutside);
    // };
  }, []);


  const handleCopyAndClose = () => {
    handleCopy();         // pehle copy kar do
    setOpenModal(false);  // phir modal band kar do
  };
  return (
    <Box my={2} sx={{ backgroundColor: "background.default" }} className='overflow-y-auto'>
      <div className="flex  justify-between gap-7  items-center">
        <div className="border-[#2B2B2B] w-full rounded-[8px] hidden sm:flex sm:flex-col border">
          <div className=" hidden sm:grid grid-cols-7 gap-8 relative  px-4 py-2 items-center">
            {/* Row 1 */}
            <p
              className={`text-[14px] font-[700] ${mode === "dark" ? "text-[#ffffff]" : "text-[#A5A5A5]"
                }`}
            >
              {title}
            </p>
            <div className="flex items-center gap-2">
              <IoMdLock style={{ color: mode == 'dark' ? '#a5a5a5' : '' }} size={16} />
              <p className="text-[14px] font-[400] text-[#A5A5A5]">
                {jobType}
              </p>
            </div>
            <div className="flex items-center gap-2">
              <img
                src="/images/salaryicon.png"
                alt=""
                style={{ width: "13px", height: "13px" }}
              />
              <p className="text-[14px] font-[400] text-[#A5A5A5]">
                {salary?.amount} CAD
              </p>
            </div>
            <div className="flex items-center gap-2">
              <img
                src="/images/yearIcon.png"
                alt=""
                style={{ width: "14px", height: "14px" }}
              />
              <p className="text-[14px] font-[400] text-[#A5A5A5]">
                {experience} Year
              </p>
            </div>
            <div className="flex items-center gap-2">
              <img
                src="/images/remoteicon.png"
                alt=""
                style={{ width: "12px", height: "14px" }}
              />
              <p className="text-[14px] font-[400] text-[#A5A5A5]">
                {remote ? "Remote" : " On Premise"}
              </p>
            </div>
            <div className="flex items-center gap-2">
              <img
                src="/images/developicon.png"
                alt=""
                style={{ width: "13px", height: "13px" }}
              />
              <p className="text-[14px] font-[400] text-[#A5A5A5]">
                {departments[departmentId]}
              </p>
            </div>
            {/* <Typography className="text-[16px] font-[400] text-[#A5A5A5]">
            {jobType}
          </Typography>
          <Typography className="text-[16px] font-[400] text-[#A5A5A5]">
            {location}
          </Typography> */}
            <Button
              sx={{
                textTransform: "capitalize",
                fontSize: "12px",
                color: "#0080FF",
                mr: 2,
              }}
              onClick={handleExpand}
              variant="text"
              endIcon={
                accordionOpen ? (
                  <MdExpandLess color="#0080FF" />
                ) : (
                  <ExpandMoreIcon color="#0080FF" />
                )
              }
            >
              Show details
            </Button>
          </div>

          {accordionOpen && (
            <Details details={details} jobType={jobType} salary={salary} />
          )}
        </div>

        <div
          className={` ${mode === "dark" ? "bg-[#171717]" : ""
            } hidden sm:flex h-[50px] rounded-md flex justify-center  items-center p-4`}
          onClick={toggleModal}
          ref={buttonRef}
        >
          <TfiMoreAlt className="relative font-extrabold" size="20px" />
        </div>
      </div>

      {/* {mobile screen} */}
      <div
        className={`${mode === "dark" ? "bg-[#171717]" : ""
          } px-2 py-4 rounded-[8px] sm:hidden relative`}
        ref={buttonRef}
      >
        <div className="flex justify-between items-center ">
          <p
            className={`text-[12px] mb-2 font-[700]  ${mode === "dark" ? "text-[#ffffff]" : ""
              } `}
          >
            {title}
          </p>

          <div className="relative">
            <IoIosMore className="relative" onClick={toggleModal} />
          </div>
        </div>

        <div className="flex items-center justify-between mb-4 flex-wrap">
          <div className="flex items-center gap-2">
            <div>
              <img src="/images/salaryicon.png" alt="" />
            </div>
            <p className="text-[10px] font-[400] text-[#A5A5A5]">
              {salary.amount} CAD
            </p>
          </div>

          <div className="flex items-center gap-2">
            <div>
              <img
                src="/images/yearIcon.png"
                alt=""
                style={{ width: "13px", height: "13px" }}
              />
            </div>
            <p className="text-[10px] font-[400] text-[#A5A5A5]">
              {experience} Year
            </p>
          </div>

          <div className="flex items-center gap-2">
            <div>
              <img src="/images/remoteicon.png" alt="" />
            </div>
            <p className="text-[10px] font-[400] text-[#A5A5A5]">
              {remote ? "Remote" : "On Premise"}
            </p>
          </div>

          <div className="flex items-center gap-2">
            <div>
              <img src="/images/developicon.png" alt="" />
            </div>
            <p className="text-[10px] font-[400] text-[#A5A5A5]">
              {departments[departmentId]}
            </p>
          </div>

          <div className="flex items-center gap-2">
            <div>
              <IoMdLock style={{ color: mode == 'dark' ? '#a5a5a5' : '' }} size={15} />
            </div>
            <p className="text-[10px] font-[400] text-[#A5A5A5]">
              {jobType}
            </p>
          </div>
        </div>

        <div className="flex justify-between items-center">
          <Button
            sx={{
              textTransform: "capitalize",
              fontSize: "12px",
              color: "#0080FF",
              mr: 2,
            }}
            onClick={handleExpand}
            variant="text"
            endIcon={
              accordionOpen ? (
                <MdExpandLess color="#0080FF" />
              ) : (
                <ExpandMoreIcon color="#0080FF" />
              )
            }
          >
            Show details
          </Button>

          <button
            style={{ height: "25px", backgroundColor: "#0080FF" }}
            className="w-max rounded-[5px] p-3 px-4 flex justify-center items-center text-[12px] text-[#fff]"
          >
            Apply Now
          </button>
        </div>

        {accordionOpen && (
          <Details details={details} jobType={jobType} salary={salary} />
        )}
      </div>

      <Modal
        sx={{ overflowY: "scroll" }}
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Toolbar>
            <IconButton
              edge="start"
              color="primary"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </Box>
      </Modal>

      {openModal && (
        <div
          ref={modalRef}
          className="absolute right-[40px] sm:right-[70px] mt-[-80px] sm:mt-[-10px] shadow-lg flex-col flex gap-3 rounded-md w-[149px] h-[121px] text-white px-4 py-3 bg-[#1B1B1B] z-10"
        >
          <div className="flex items-center gap-3" onClick={() => editJob(id)}>
            <TbEdit sx={{ fontSize: '20px' }} />
            <p>Edit</p>
          </div>

          <div className="flex items-center gap-3" onClick={handleCopyAndClose}>
            <ContentCopyIcon fontSize="small" />
            <p>Copy</p>
          </div>

          {/* onClick={() => OpenDeleteModal(id)} */}
          <div className="flex items-center gap-3" onClick={OpenDeleteModal}>
            <DeleteIcon fontSize="small" />

            <p>Delete</p>
          </div>
        </div>
      )}
      {deletingModal && (
        <Modal
          open={OpenDeleteModal}
          onClose={CloseDeleteModal}>
          <Box
            sx={{ backgroundColor: "background.paper" }}
            className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 p-6 rounded-lg shadow-lg w-[90%] md:w-[450px]"
          >
            {/* Title */}
            <h2 className="text-lg font-bold mb-3">Delete Job Field</h2>

            {/* Message */}
            <p className="text-sm mb-2 text-[#A5A5A5]">
              Are you sure you want to delete <b>{title}</b>?
            </p>
            <p className="text-red-500 text-sm mt-10 my-5">
              This action cannot be undone.
            </p>

            {/* Buttons */}
            <div className="flex justify-end gap-3">
              <Button
                onClick={() => {
                  deletejob(id);
                  CloseDeleteModal();
                }}
                color="error"
                variant="outlined"
                sx={{ paddingX: { md: 2, xs: 0 } }}
              >
                Delete
              </Button>
              <Button
                onClick={CloseDeleteModal}
                color="primary"
                variant="contained"
                sx={{ bgcolor: "#0080FF", borderRadius: "5px" }}
              >
                Cancel
              </Button>
            </div>
          </Box>
        </Modal >
      )}
      {/* {deletingModal && (
        <Dialog
          maxWidth="sm"
          fullWidth
          open={OpenDeleteModal}
          onClose={CloseDeleteModal}
        >
          <div
            className="p-[10px] sm:p-[20px] rounded-lg"
            style={{ backgroundColor: mode === "dark" ? "#171717" : "" }}
          >
            <DialogTitle>Delete Job Field</DialogTitle>
            <DialogContent
              sx={{ backgroundColor: mode === "dark" ? "#171717" : "" }}
            >
              <p className="text-[#A5A5A5] text-[10px] sm:text-[14px]">
                Are you sure you want to delete <b>{title}</b>?
              </p>
              <p className="text-[#FF3D3D] mt-[30px] text-[10px] sm:text-[14px]">
                This action cannot be undone.
              </p>
            </DialogContent>
            <DialogActions
              sx={{ backgroundColor: mode === "dark" ? "#171717" : "" }}
            >
              <Button
                onClick={() => {
                  deletejob(id);
                  CloseDeleteModal();
                }}
                color="error"
                variant="outlined"
                sx={{ paddingX: { md: 2, xs: 0 } }}
              >
                Delete
              </Button>
              <Button
                onClick={CloseDeleteModal}
                color="primary"
                variant="contained"
                sx={{ bgcolor: "#0080FF", borderRadius: "5px" }}
              >
                Cancel
              </Button>
            </DialogActions>
          </div>
        </Dialog>
      )} */}
    </Box>
  );
};

export default JobListingCard;
